import { ClickToComponent } from 'click-to-react-component';
import { createRoot } from 'react-dom/client';

import App from 'app/App';
import 'lib/amplitude/init';
import 'lib/hotjar/init';
import 'shared_DEPRECATED/config/date';

import { TurnOffDefaultPropsWarning } from './lib/recharts/suppressWarning';

const root = createRoot(document.getElementById('root'));
root.render(
  <>
    <ClickToComponent editor="cursor" />
    <TurnOffDefaultPropsWarning />
    <App />
  </>
);
